export default __webpack_public_path__ + "static/media/icons.36663f77.svg";